const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);
const PLACEHOLDER_PATTERNS = [
  /(^|[.@/:_-])example\.(com|org|net)(\W|$)/,
  /(^|[/:@_-])your[-_\w]*($|[/:@_-])/,
  /(^|[/:@_-])placeholder($|[/:@_-])/,
];

function requireProductionUrl(key) {
  const value = process.env[key];
  if (process.env.NODE_ENV !== 'production') return value;

  if (!value) {
    throw new Error(`${key} must be configured for production builds`);
  }
  const normalized = value.toLowerCase();
  if (PLACEHOLDER_PATTERNS.some(pattern => pattern.test(normalized))) {
    throw new Error(`${key} must be a real HTTPS production URL`);
  }

  let url;
  try {
    url = new URL(value);
  } catch {
    throw new Error(`${key} must be a valid HTTPS production URL`);
  }

  if (url.protocol !== 'https:' || LOCAL_HOSTS.has(url.hostname)) {
    throw new Error(`${key} must be a valid HTTPS production URL`);
  }

  return value;
}

export const API_BASE_URL = requireProductionUrl('REACT_APP_API_BASE_URL') || 'http://localhost:3001/api';
